// import React, { useEffect, useState } from "react";
// import { Box, Typography, IconButton } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import AddImage from "../../../assets/icons/addImage.svg";
// import ImageCropperDialog from "../../ImageCropper";
// import EditIcon from "@mui/icons-material/Edit";


// const ImageUploader = ({
//   label = "Upload Image",
//   file,
//   setFile,
//   preview,
//   setPreview,
//   uploader,
//   isFromPatientProfile = false,
// }) => {
//   const [cropOpen, setCropOpen] = useState(false);
//   const [imageSrc, setImageSrc] = useState(null);
//   const inputRef = React.useRef(null);

//   const handleSelect = (e) => {
//     const selected = e.target.files?.[0];
//     if (!selected) return;

//     const reader = new FileReader();
//     reader.onload = () => {
//       setImageSrc(reader.result);
//       setCropOpen(true);
//     };
//     reader.readAsDataURL(selected);
//   };

//   const handleCroppedImage = (croppedFile) => {
//     if (!croppedFile) return;

//     if (preview?.startsWith("blob:")) {
//       URL.revokeObjectURL(preview);
//     }

//     const previewUrl = URL.createObjectURL(croppedFile);
//     setFile(croppedFile);
//     setPreview(previewUrl);
//     setCropOpen(false);
//     if (inputRef.current) {
//       inputRef.current.value = "";
//     }
//   };

//   const handleRemove = () => {
//     if (preview?.startsWith("blob:")) {
//       URL.revokeObjectURL(preview);
//     }
//     setFile(null);
//     setPreview(null);
//     if (inputRef.current) {
//       inputRef.current.value = "";
//     }
//   };

//   useEffect(() => {
//     return () => {
//       if (preview?.startsWith("blob:")) {
//         URL.revokeObjectURL(preview);
//       }
//     };
//   }, [preview]);

//   const isPreview = Boolean(preview);

//   return (
//     <Box>
//       <Typography sx={{ fontSize: 14, color: "var(--app-text-muted)", mb: 1, fontWeight: 500 }}>
//         {label}
//       </Typography>

//       {/* Upload card */}
//       <Box
//         component="label"
//         sx={{
//           width: uploader === "signature" ? 200 : isFromPatientProfile ? 70 : 100,
//           height: uploader === "signature" ? 200 : isFromPatientProfile ? 70 : 100,
//           borderRadius: 2,
//           cursor: "pointer",
//           position: "relative",
//           overflow: "hidden",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           border: isPreview ? "1px solid var(--app-border)" : "1px dashed #5B5AFB",
//           backgroundColor: isPreview ? "#FFFFFF" : "#F5F6FF",
//           borderRadius: isFromPatientProfile ? "50%" : 2,
//         }}
//       >
//         {!isPreview && (
//           <Box
//             sx={{
//               position: "absolute",
//               inset: 0,
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               textAlign: "center",
//             }}
//           >
//             <Box sx={{ mb: 1 }}>
//               <img src={AddImage} alt="add" />
//             </Box>
//             {!isFromPatientProfile && (
//               <Typography sx={{ fontSize: 14, fontWeight: 500, color: "var(--app-text-muted)" }}>
//                 Add Image
//               </Typography>
//             )}

//           </Box>
//         )}

//         {isPreview && (
//           <>
//             <img
//               src={preview}
//               alt="preview"
//               style={{
//                 maxWidth: "100%",
//                 maxHeight: "100%",
//                 objectFit: "cover",
//               }}
//             />
//             <IconButton
//               size="small"
//               onClick={(e) => {
//                 e.preventDefault();
//                 e.stopPropagation();
//                 handleRemove();
//               }}
//               sx={{
//                 position: "absolute",
//                 top: isFromPatientProfile ? 6 : 0,
//                 right: isFromPatientProfile ? 6 : 0,
//                 backgroundColor: "var(--app-text)",
//                 color: "#fff",
//                 width: 22,
//                 height: 22,
//                 "&:hover": { backgroundColor: "var(--app-text)" },
//               }}
//             >
//               <CloseIcon sx={{ fontSize: 14 }} />
//             </IconButton>
//           </>
//         )}

//         <input
//           ref={inputRef}
//           hidden
//           type="file"
//           accept="image/png,image/jpeg,image/jpg"
//           onChange={handleSelect}
//         />
//       </Box>


//       <ImageCropperDialog
//         open={cropOpen}
//         imageSrc={imageSrc}
//         aspect={1}
//         onClose={() => setCropOpen(false)}
//         onSave={handleCroppedImage}
//       />
//     </Box>
//   );
// };

// export default ImageUploader;

import React, { useEffect, useState, useRef } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddImage from "../../../assets/icons/addImage.svg";
import ImageCropperDialog from "../../ImageCropper";

const ImageUploader = ({
  label = "Upload Image",
  file,
  setFile,
  preview,
  setPreview,
  uploader,
  isFromPatientProfile = false,
}) => {
  const [cropOpen, setCropOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const inputRef = useRef(null);

  const handleSelect = (e) => {
    const selected = e.target.files?.[0];
    if (!selected) return;
    e.target.value = "";

    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
      setCropOpen(true);
    };
    reader.readAsDataURL(selected);
  };

  const handleCroppedImage = (croppedFile) => {
    if (!croppedFile) return;

    if (preview?.startsWith("blob:")) {
      URL.revokeObjectURL(preview);
    }

    const previewUrl = URL.createObjectURL(croppedFile);
    setFile(croppedFile);
    setPreview(previewUrl);
    setCropOpen(false);

    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const handleRemove = (e) => {
    e.stopPropagation();

    if (preview?.startsWith("blob:")) {
      URL.revokeObjectURL(preview);
    }

    setFile(null);
    setPreview(null);

    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  useEffect(() => {
    return () => {
      if (preview?.startsWith("blob:")) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  const isPreview = Boolean(preview);

  return (
    <Box>
      {label && !isFromPatientProfile && (
        <Typography
          sx={{
            fontSize: 14,
            color: "var(--app-text-muted)",
            mb: 1,
            fontWeight: 500,
          }}
        >
          {label}
        </Typography>
      )}

      <Box
        sx={{
          width:
            uploader === "signature"
              ? 200
              : isFromPatientProfile
              ? 70
              : 100,
          height:
            uploader === "signature"
              ? 200
              : isFromPatientProfile
              ? 70
              : 100,
          cursor: !isPreview ? "pointer" : "default",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: isPreview
            ? "1px solid var(--app-border)"
            : "1px dashed #5B5AFB",
          backgroundColor: isPreview ? "var(--app-surface)" : "var(--app-surface-2)",
          borderRadius: isFromPatientProfile ? "50%" : 2,
        }}
        onClick={() => {
          if (!isPreview) {
            inputRef.current?.click();
          }
        }}
      >
        {!isPreview && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <Box sx={{ mb: 1 }}>
              <img src={AddImage} alt="add" />
            </Box>

            {!isFromPatientProfile && (
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: "var(--app-text-muted)",
                }}
              >
                Add Image
              </Typography>
            )}
          </Box>
        )}

        {isPreview && (
          <>
            <img
              src={preview}
              alt="preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />

            <IconButton
              size="small"
              onClick={handleRemove}
              sx={{
                position: "absolute",
                top: isFromPatientProfile ? 6 : 0,
                right: isFromPatientProfile ? 6 : 0,
                backgroundColor: "var(--app-text)",
                color: "#fff",
                width: 22,
                height: 22,
                "&:hover": { backgroundColor: "var(--app-text)" },
              }}
            >
              <CloseIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </>
        )}

        <input
          ref={inputRef}
          hidden
          type="file"
          accept="image/png,image/jpeg,image/jpg"
          onChange={handleSelect}
        />
      </Box>

      <ImageCropperDialog
        open={cropOpen}
        imageSrc={imageSrc}
        aspect={1}
        onClose={() => setCropOpen(false)}
        onSave={handleCroppedImage}
      />
    </Box>
  );
};

export default ImageUploader;